module.exports = __webpack_public_path__ + "files/6077fce7019a9ca6f33d777c5c23e185.png";